export default __webpack_public_path__ + "static/media/MiturWhiteLogo.3da2dbc8.png";